<template>
<div id="member">
    <mMember v-if="$store.state.device == 'mob'" />
    <pMember v-if="$store.state.device == 'pc'" />
</div>
</template>

<script>
import mMember from '@/components/mMember.vue'
import pMember from '@/components/pMember.vue'
export default {
    name: 'Member',
    data (){
        return {

        }
    },
    components: {
        mMember,
        pMember,
    },
    computed: {

    },
    methods: {

    },
    mounted () {

    }
}
</script>

<style lang="scss" scoped>

</style>
